module.exports = __webpack_public_path__ + "img/mobile_high-1umx.8acda1f0.png";